module.exports = __webpack_public_path__ + "img/تمر-صورة.9b8a3996.png";